module.exports = "<div>This is the dashboard view.</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/account/dashboard/dashboard.html
// module id = 48
// module chunks = 0